export default {
  CHAT: 'Chat',
  CHAT_SYSTEM_MESSAGE_SECURE_CHAT: `Este chat seguro solo puede ser visto por las personas en esta llamada.`,
  CHAT_SYSTEM_MESSAGE_ALONE_IN_CHAT: `Los nuevos mensajes se podrán ver cuando alguien se reincorpore a la llamada.`,
  CHAT_MESSAGE_META_TAG_REMOTE: `{{name}} a las {{timestamp}}`,
  CHAT_MESSAGE_META_TAG_LOCAL: `Tú a las {{timestamp}}`,
  CHAT_TYPING_INDICATOR_MULTIPLE_USERS_META: `Varios usuarios están escribiendo...`,
  CHAT_TYPING_INDICATOR_META: `{{name}} está escribiendo...`,
  CHAT_MESSAGE_INPUT_PLACEHOLDER: 'Escribe aquí tu mensaje',
  CHAT_JOIN_ERROR_RETRY_HEADER: `Tenemos problemas para cargar el chat.`,
  CHAT_JOIN_ERROR_RETRY_SUB_TEXT: `Por favor, intenta volver a cargar y ver si eso soluciona el problema.`,
  CHAT_JOIN_ERROR_TRY_RELOAD_BTN: `Intenta volver a cargar`,
  CHAT_JOIN_ERROR_BACK_TO_CALL_BTN: `Volver a la llamada`,
  CHAT_JOIN_ERROR_RELOADING_BTN: `Recargando`,
  CHAT_JOIN_ERROR_DISABLED_BTN: `Volver a cargar el chat`,
  CHAT_JOIN_ERROR_HEADER: `Lo sentimos, no podemos cargar el chat.`,
  CHAT_JOIN_ERROR_SUB_TEXT: `Por favor, vuelve a la llamada. Pedimos disculpas por este problema técnico.`,
  CHAT_WELCOME: `Bienvenido al chat`,
  CHAT_DISABLED_WITHOUT_PROVIDER: `Podrás enviar mensajes después de que el equipo médico se una a la llamada.`,
  CHAT_NEW_FEATURE: `Esta nueva función aún no está completamente activada para todos.`,
  CHAT_ATTENTION: `Cuando escribas en el chat, verifica con las otras personas en la llamada si pueden ver tu mensaje. Gracias por tu paciencia mientras mejoramos esta función.`,
  CHAT_TOAST_HEADER: `Chat de {{senderName}}`,
  CHAT_TOAST_REPLY: `Responder`,
  CHAT_MESSAGE_FAILURE_META: `Mensaje no entregado`,
};
